import { Clock, FileText, Frown } from "lucide-react";

const METRICS = [
  {
    value: "2 hrs",
    label: "Lost to paperwork every single day",
    Icon: Clock,
  },
  {
    value: "30+",
    label: "Fields to fill across SOAP & history",
    Icon: FileText,
  },
  {
    value: "Top 3",
    label: "Cited cause of after-hours work for physios",
    Icon: Frown,
  },
];

export default function Problem() {
  return (
    <section
      className="relative bg-[#064E3B] text-white overflow-hidden grain-bg"
      data-testid="problem-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <div className="rounded-3xl overflow-hidden shadow-[0_30px_60px_rgba(0,0,0,0.35)] border border-white/10">
            <img
              src="https://images.pexels.com/photos/4989132/pexels-photo-4989132.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Clinician overwhelmed by paperwork after a long day"
              className="w-full h-[420px] object-cover"
            />
          </div>
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-[#064E3B]/60 to-transparent pointer-events-none" />
        </div>

        <div className="lg:col-span-7">
          <span className="font-figtree text-xs uppercase tracking-[0.22em] font-semibold text-[#86EFAC]">
            The problem
          </span>
          <h2 className="mt-3 font-outfit text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] text-white">
            You didn't study for six years to do data entry.
          </h2>
          <p className="mt-5 font-figtree text-base sm:text-lg text-[#D1FAE5]/90 leading-relaxed max-w-2xl">
            Every session ends the same way. The patient leaves, and you stay
            behind retyping what you already remember — Assessment, Objective,
            Goals, History — visit after visit. It is slow, repetitive, and the
            cost is real: less time with patients, longer days, and a quiet,
            grinding burnout.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-5">
            {METRICS.map(({ value, label, Icon }) => (
              <div
                key={label}
                className="rounded-2xl bg-white/5 backdrop-blur-md border border-white/10 p-5"
              >
                <Icon className="w-5 h-5 text-[#86EFAC] mb-3" />
                <div className="font-outfit text-3xl font-bold text-white">
                  {value}
                </div>
                <div className="mt-1 font-figtree text-sm text-[#D1FAE5]/80 leading-snug">
                  {label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
